import React from "react";
import "./button.css";

function Button({ title, className, onClick }) {
  return (
    <button className={className} onClick={onClick}>
      {title}
    </button>
  );
}

export default Button;
